import React from 'react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { wagmiConfig } from './config';

const queryClient = new QueryClient();

type TProps = {
  children: React.ReactNode;
};

export const WagmiWrp: React.FC<TProps> = ({ children }) => (
  // @ts-ignore
  <WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  </WagmiProvider>
);
